<template>
  <b-modal
    id="event-user-list-modal"
    :visible="_value"
    hide-header
    hide-footer
    dialog-class="event-user-list-modal"
    body-class="event-user-list-modal-body"
    @hidden="_value = false">
    <div
      class="event-user-list-modal-cross">
      <b-icon-x-circle-fill
        style="cursor: pointer;"
        @click="_value = false" />
    </div>
    <div class="event-user-list-modal__event pb-2">
      <div class="event-user-list-modal__event-date">
        <span class="event-user-list-modal__event-date-date">
          {{ event.startAt | prettyMdWithJpWeekDay }}
        </span>
        <span class="event-user-list-modal__event-date-start-at">
          {{ event.startAt | prettyHHmm }}
        </span>
        〜
        <span class="event-user-list-modal__event-date-start-at">
          {{ event.endAt | prettyHHmm }}
        </span>
      </div>
      <div class="event-user-list-modal__category">
        [{{ event.category.name }}]
      </div>
      <div class="event-user-list-modal__event-title">
        {{ event.title }}
      </div>
    </div>
    <div class="d-flex flex-wrap justify-content-between">
      <div
        class="event-user-list-modal__attend-users flex-grow-1"
        :class="[mainUserType === 'attend' ? 'd-block' : 'd-none d-lg-block']">
        <div class="text--grey05 d-flex align-items-center mt-3">
          <span
            class="material-icons mr-1"
            style="font-size: 1rem;">person_add</span>
          <span>参加する人</span>
          <span class="event-user-list-modal__attend-users-count ml-2">
            {{ attendUsers.length }}人
          </span>
        </div>

        <div class="mt-3">
          <div v-if="attendUsers.length > 0">
            <app-list-item
              v-for="user in attendUsers"
              :key="user.id"
              :avatar="user.avatar"
              :name="user.name"
              :group="user.department.name"
              :position="user.position" />
          </div>
          <p
            v-else
            style="font-size: 14px;">
            この予定にはまだ参加する人がいません
          </p>
        </div>
      </div>

      <div
        class="event-user-list-modal__absence-users flex-grow-1"
        :class="[mainUserType === 'absence' ? 'd-block' : 'd-none d-lg-block']">
        <div class="text--grey05 d-flex align-items-center mt-3">
          <span
            class="material-icons mr-1"
            style="font-size: 1rem;">person_remove</span>
          <span>参加しない人</span>
          <span class="event-user-list-modal__absence-users-count ml-2">
            {{ absenceUsers.length }}人
          </span>
        </div>
        <div class="mt-3">
          <div v-if="absenceUsers.length > 0">
            <app-list-item
              v-for="user in absenceUsers"
              :key="user.id"
              :avatar="user.avatar"
              :name="user.name"
              :group="user.department.name"
              :position="user.position" />
          </div>
          <p
            v-else
            style="font-size: 14px;">
            この予定にはまだ参加しない人がいません
          </p>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import AppListItem from '@/components/parts/AppListItem'
export default {
  components: {
    AppListItem
  },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    event: {
      type: Object,
      required: true
    },
    attendUsers: {
      type: Array,
      required: true
    },
    absenceUsers: {
      type: Array,
      required: true
    },
    // メインとなるユーザ一覧のタイプ
    // attend: 参加する人
    // absence: 参加しない人
    mainUserType: {
      type: String,
      required: true
    }
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.event-user-list-modal {

  &-body {
    position: relative;
  }

  &-cross {
    position: absolute;
    top: 5px;
    right: 5px;
    display: flex;
    justify-content: flex-end;
    font-size: 20px;
    color: $grey04;
  }

  &__event {
    display: flex;
    gap: 16px;
    align-items: center;
    flex-wrap: wrap;
  }
}
</style>

<style lang="scss">
.event-user-list-modal {
  max-width: 700px !important;
}
</style>
